
import React from "react";
import ValueProposition from "@/components/ValueProposition";
import SpecialFormatsHeader from "./SpecialFormatsHeader";
import CoachingLocationCard from "./CoachingLocationCard";
import AdditionalLocations from "./AdditionalLocations";

const SpecialFormatsInspiration = () => {
  return (
    <section className="section-spacing bg-white">
      <div className="container px-4">
        <SpecialFormatsHeader 
          title="Neue Perspektiven durch besondere Orte"
          subtitle="Coaching in inspirierender Umgebung"
          description="Manchmal braucht es einen Ortswechsel oder Perspektivwechsel, um neue Lösungen zu finden. Deshalb biete ich Coaching-Sessions an inspirierenden Orten an – überall dort, wo wir aus der rationalen Denkweise ausbrechen und kreative Blickwinkel entdecken können."
        />


        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Rothsee Card */}
          <CoachingLocationCard 
            title="Outdoor Coaching am Rothsee"
            description="Erlebe Coaching in einer inspirierenden Naturkulisse. Der Rothsee bietet die perfekte Umgebung, um aus gewohnten Denkmustern auszubrechen."
            imageUrl="/lovable-uploads/7362f790-8e3a-4e34-abe3-ab5d3bcea312.png"
            imageAlt="Rothsee bei Sonnenschein - Idyllische Umgebung für Outdoor Coaching"
            features={[
              { text: "Walk & Talk: Bewegung aktiviert beide Gehirnhälften" },
              { text: "Inspirierendes Umfeld für kreative Lösungsansätze" }
            ]}
            ctaText="Mehr erfahren"
            ctaLink="/outdoor-coaching"
          />

          {/* Alpine Coaching */}
          <CoachingLocationCard 
            title="Coaching in den Alpen"
            description="Die majestätischen Berge der Alpen sind eine Kraftquelle und bieten den perfekten Rahmen für tiefgreifende Coaching-Erlebnisse."
            imageUrl="/lovable-uploads/a3926081-0524-49fd-befa-4825f953f8ee.png"
            imageAlt="Majestätische Alpenlandschaft - Umgebung für Coaching in den Bergen"
            features={[
              { text: "Intensives Coaching in kraftvoller Bergkulisse" },
              { text: "Besondere Perspektiven durch den Wechsel aus deinem Alltag" },
              { text: "Individuelles Angebot nach Absprache" }
            ]}
            ctaText="Angebot anfragen"
            ctaLink="/kontakt"
          />
        </div>

        {/* Additional locations section */}
        <AdditionalLocations />
      </div>
    </section>
  );
};

export default SpecialFormatsInspiration;
